import map from 'lodash/map';

export const setConfig = config => (
  {
    type: 'CONFIG/SET',
    config,
  }
);

export const setGlobalMessage = (global_message, global_message_type) => (
  {
    type: 'CONFIG/SET_GLOBAL_MESSAGE',
    global_message,
    global_message_type,
  }
);

export const setSocketStatus = (is_up) => (
  {
    type: 'CONFIG/SET_SOCKET_STATUS',
    is_up,
  }
);

export default setConfig;

export const getLocaleList = (state) => {
  const { config: { available_locales } } = state;
  return map(available_locales, (value, key) => {
    return {
      value: key,
      label: value,
    };
  });
};
